import React from 'react';


const ProgressIndicator = ({ agents, currentAgentId }) => {
  const currentIndex = agents?.findIndex(a => a?.id === currentAgentId);
  const completedCount = agents?.filter(a => a?.status === 'completed')?.length;
  const progressPercentage = (completedCount / agents?.length) * 100;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-heading font-semibold text-foreground">
          Workflow Progress
        </h3>
        <span className="text-xs font-mono text-muted-foreground">
          {completedCount}/{agents?.length} Complete
        </span>
      </div>
      <div className="relative w-full h-2 bg-muted rounded-full overflow-hidden">
        <div
          className="absolute top-0 left-0 h-full bg-primary transition-all duration-400 ease-in-out"
          style={{ width: `${progressPercentage}%` }}
        />
      </div>
      <div className="flex items-center justify-between text-xs text-muted-foreground">
        <span>Step {currentIndex + 1} of {agents?.length}</span>
        <span>{Math.round(progressPercentage)}% Complete</span>
      </div>
      <div className="grid grid-cols-11 gap-1">
        {agents?.map((agent, index) => {
          const isCompleted = agent?.status === 'completed';
          const isCurrent = agent?.id === currentAgentId;
          const isLocked = agent?.status === 'locked';

          return (
            <div
              key={agent?.id}
              className={`h-1.5 rounded-full transition-all duration-200 ${
                isCompleted
                  ? 'bg-success'
                  : isCurrent
                  ? 'bg-primary'
                  : isLocked
                  ? 'bg-muted' :'bg-muted'
              }`}
              title={agent?.name}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ProgressIndicator;